import PropTypes from 'prop-types';
import React from 'react';
import Select, { Creatable } from 'react-select';

class MultipleChoiceDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.initialValue,
        };

        this.handleChange = this.handleChange.bind(this);
        this.promptTextCreator = this.promptTextCreator.bind(this);
    }

    handleChange(value) {
        this.setState({
            value: value,
        });

        this.props.onChange(value);
    }

    promptTextCreator(label) {
        return `${this.props.createOptionLabel} "${label}"`;
    }

    render() {
        return (
            <Creatable
                multi={true}
                clearable={false}
                className={this.props.className}
                joinValues={this.props.joinValues}
                options={this.props.options}
                placeholder={this.props.placeholder}
                value={this.state.value}
                onChange={this.handleChange}
                promptTextCreator={this.promptTextCreator}
            >
                {() => (
                    <Select
                        multi={true}
                        clearable={false}
                        className={this.props.className}
                        joinValues={this.props.joinValues}
                        options={this.props.options}
                        placeholder={this.props.placeholder}
                        value={this.state.value}
                        onChange={this.handleChange}
                    />
                )}
            </Creatable>
        );
    }
}

MultipleChoiceDropdown.propTypes = {
    className: PropTypes.string,
    joinValues: PropTypes.bool,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    createOptionLabel: PropTypes.string,
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    onChange: PropTypes.func.isRequired,
};

MultipleChoiceDropdown.defaultProps = {
    className: '',
    joinValues: false,
    options: [],
    placeholder: '',
    createOptionLabel: '',
};

export default MultipleChoiceDropdown;



// WEBPACK FOOTER //
// ./src/web/js/app/components/multiple-choice-dropdown.jsx